"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApproveAttestationResponseToJSON = exports.ApproveAttestationResponseFromJSONTyped = exports.ApproveAttestationResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
function ApproveAttestationResponseFromJSON(json) {
    return ApproveAttestationResponseFromJSONTyped(json, false);
}
exports.ApproveAttestationResponseFromJSON = ApproveAttestationResponseFromJSON;
function ApproveAttestationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
        'attestationId': !(0, runtime_1.exists)(json, 'attestationId') ? undefined : json['attestationId'],
        'approvedUsdAmount': !(0, runtime_1.exists)(json, 'approvedUsdAmount') ? undefined : json['approvedUsdAmount'],
        'sharesAllocated': !(0, runtime_1.exists)(json, 'sharesAllocated') ? undefined : json['sharesAllocated'],
        'message': !(0, runtime_1.exists)(json, 'message') ? undefined : json['message'],
    };
}
exports.ApproveAttestationResponseFromJSONTyped = ApproveAttestationResponseFromJSONTyped;
function ApproveAttestationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'attestationId': value.attestationId,
        'approvedUsdAmount': value.approvedUsdAmount,
        'sharesAllocated': value.sharesAllocated,
        'message': value.message,
    };
}
exports.ApproveAttestationResponseToJSON = ApproveAttestationResponseToJSON;
